import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import { Condition } from "@/keyboard";
import { isCondLogic, ConditionTypeLogic } from "@/keyboard/leds";
import ConditionViewLogic from "@/components/leds/ConditionViewLogic.vue";
import ConditionViewValue from "@/components/leds/ConditionViewValue.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'ConditionView',
  props: {
    condition: {},
    parentLogic: {}
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_unref(isCondLogic)(_ctx.condition))
    ? (_openBlock(), _createBlock(ConditionViewLogic, {
        key: 0,
        condition: _ctx.condition,
        parentLogic: _ctx.parentLogic
      }, null, 8, ["condition", "parentLogic"]))
    : (_openBlock(), _createBlock(ConditionViewValue, {
        key: 1,
        condition: _ctx.condition
      }, null, 8, ["condition"]))
}
}

})